import { Component, Input } from '@angular/core';
import { DatSegmentDetail } from '../../models/monitoring.models';
import { StatusPillComponent } from './ui-shell.component';

@Component({
  selector: 'app-dat-detail-card',
  standalone: true,
  imports: [StatusPillComponent],
  template: `
    @if (detail) {
      <article class="detail-card">
        <h2 class="card-title">{{ detail.datName }} ({{ detail.stationName }})</h2>
        <p class="card-status">
          Etat <app-status-pill [color]="detail.color" />
          de {{ detail.startLabel }} à {{ detail.endLabel }}
        </p>
        @if (detail.issueStartedLabel) {
          <p class="issue-started">Incident signalé à {{ detail.issueStartedLabel }}</p>
        }
        <p class="card-date">le {{ detail.date }}</p>
        <!-- Formats attendus (spéc. 30/06) :
             « Imprimante reçu : HS (KO : 10h32) » — toujours KO à la fin du créneau ;
             « TPE : OK (KO : 10h25, OK : 10h34) » — repassé OK dans le même créneau. -->
        <ul class="organs">
          @for (organ of detail.organs; track organ.name) {
            <li class="organ-row">
              <span class="organ-name">{{ organ.name }}</span>
              <span class="organ-state">
                <span
                  class="status-badge"
                  [class.ok]="organ.status === 'OK'"
                  [class.hs]="organ.status === 'HS'"
                >
                  {{ organ.status }}
                </span>
                @if (organ.koLabel) {
                  <span class="event-chip ko" [title]="'Passage HS à ' + organ.koLabel">
                    <span class="chip-dot" aria-hidden="true"></span>KO {{ organ.koLabel }}
                  </span>
                }
                @if (organ.okLabel) {
                  <span class="chip-arrow" aria-hidden="true">→</span>
                  <span class="event-chip back-ok" [title]="'Retour OK à ' + organ.okLabel">
                    <span class="chip-dot" aria-hidden="true"></span>OK {{ organ.okLabel }}
                  </span>
                }
              </span>
            </li>
          }
        </ul>
      </article>
    }
  `,
  styles: [
    `
      .detail-card {
        border: 1px solid #555;
        border-radius: 6px;
        padding: 1.25rem 1.5rem;
        background: #fff;
        max-width: 22rem;
        margin: 0 auto;
      }

      .card-title {
        text-align: center;
        margin: 0 0 0.75rem;
        font-size: 1.05rem;
        font-weight: 600;
      }

      .card-status {
        text-align: center;
        margin: 0 0 0.25rem;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.35rem;
        flex-wrap: wrap;
      }

      .issue-started {
        text-align: center;
        margin: 0 0 0.25rem;
        font-size: 0.9rem;
        color: #c62828;
        font-weight: 500;
      }

      .card-date {
        text-align: center;
        margin: 0 0 1rem;
        color: #444;
      }

      .organs {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
      }

      .organ-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.5rem;
        padding: 0.45rem 0.25rem;
        flex-wrap: wrap;
      }

      .organ-row + .organ-row {
        border-top: 1px solid #eee;
      }

      .organ-name {
        font-size: 0.95rem;
      }

      .organ-state {
        display: inline-flex;
        align-items: center;
        gap: 0.35rem;
        flex-wrap: wrap;
      }

      .status-badge {
        display: inline-block;
        min-width: 2.1rem;
        text-align: center;
        padding: 0.1rem 0.5rem;
        border-radius: 999px;
        font-size: 0.8rem;
        font-weight: 700;
      }

      .status-badge.ok {
        color: #2e7d32;
        background: #e8f5e9;
      }

      .status-badge.hs {
        color: #c62828;
        background: #fdecea;
      }

      .event-chip {
        display: inline-flex;
        align-items: center;
        gap: 0.3rem;
        padding: 0.1rem 0.5rem;
        border-radius: 999px;
        font-size: 0.75rem;
        font-weight: 600;
        white-space: nowrap;
      }

      .event-chip.ko {
        color: #b71c1c;
        background: #fff0ef;
        border: 1px solid #f5c6c4;
      }

      .event-chip.back-ok {
        color: #1b5e20;
        background: #f0f8f1;
        border: 1px solid #c3e0c6;
      }

      .chip-dot {
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 50%;
        background: currentColor;
      }

      .chip-arrow {
        color: #999;
        font-size: 0.75rem;
      }
    `,
  ],
})
export class DatDetailCardComponent {
  @Input() detail: DatSegmentDetail | null = null;
}
